import { firestoreDatabase } from 'lib/firebaseService';

export const countOwnedOffers = async (
  uid: string,
): Promise<number> => {
  const ownOffers = await firestoreDatabase.getList({
    resource: 'Offers',
    filters: [
      {
        field: 'created_by_uid',
        operator: 'eq',
        value: uid,
      },
    ],
  });

  return ownOffers.total || ownOffers.data.length;
};
